import * as React from "react";
import { IconProps } from "./IconProps";

export const IconMagnifyingGlass = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.83333 3.33333C5.62419 3.33333 3.83333 5.12419 3.83333 7.33333C3.83333 9.54247 5.62419 11.3333 7.83333 11.3333C10.0425 11.3333 11.8333 9.54247 11.8333 7.33333C11.8333 5.12419 10.0425 3.33333 7.83333 3.33333ZM2.5 7.33333C2.5 4.38781 4.88781 2 7.83333 2C10.7789 2 13.1667 4.38781 13.1667 7.33333C13.1667 8.56581 12.7486 9.70064 12.0466 10.6038L14.3047 12.8619C14.5651 13.1223 14.5651 13.5444 14.3047 13.8047C14.0444 14.0651 13.6223 14.0651 13.3619 13.8047L11.1038 11.5466C10.2006 12.2486 9.06581 12.6667 7.83333 12.6667C4.88781 12.6667 2.5 10.2789 2.5 7.33333ZM7.83333 4.66667C8.20152 4.66667 8.5 4.96514 8.5 5.33333V6.66667H9.83333C10.2015 6.66667 10.5 6.96514 10.5 7.33333C10.5 7.70152 10.2015 8 9.83333 8H8.5V9.33333C8.5 9.70152 8.20152 10 7.83333 10C7.46514 10 7.16667 9.70152 7.16667 9.33333V8H5.83333C5.46514 8 5.16667 7.70152 5.16667 7.33333C5.16667 6.96514 5.46514 6.66667 5.83333 6.66667H7.16667V5.33333C7.16667 4.96514 7.46514 4.66667 7.83333 4.66667Z"
          fill={color}
        />
      </svg>
    );
  },
);
